import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "pb-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "flex items-end justify-center mb-3" }
const _hoisted_15 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5" }
const _hoisted_16 = { class: "flex flex-col mb-3" }
const _hoisted_17 = { class: "flex flex-col pb-3" }
const _hoisted_18 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_19 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = { class: "flex flex-col pb-3" }
const _hoisted_22 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_23 = { class: "mr-2" }
const _hoisted_24 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = { class: "flex flex-col pb-3" }
const _hoisted_27 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_28 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_29 = { class: "ml-2" }
const _hoisted_30 = { class: "flex flex-col pb-3" }
const _hoisted_31 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_32 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_33 = { class: "ml-2" }
const _hoisted_34 = { class: "flex flex-col pb-3" }
const _hoisted_35 = { class: "col-start-1 flex flex-col pb-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "flex justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_AnagraficaAzienda = _resolveComponent("AnagraficaAzienda")!
  const _component_AnagraficaDenominazione = _resolveComponent("AnagraficaDenominazione")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.show_error_form)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            dismissable: true,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_error_form = false)),
            class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
          }, {
            default: _withCtx(() => _cache[52] || (_cache[52] = [
              _createTextVNode(" Correggi gli errori di inserimento ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back())),
            class: "w-48 hidden text-sm sm:block py-2 px-4"
          }, {
            default: _withCtx(() => _cache[53] || (_cache[53] = [
              _createTextVNode(" < Indietro ")
            ])),
            _: 1
          })
        ])
      ]),
      _cache[69] || (_cache[69] = _createElementVNode("h3", { class: "text-3xl font-bold mb-3" }, "Nuovo Cliente", -1)),
      (_ctx.permission_denied)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            dismissable: true,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.permission_denied = false)),
            class: "bg-next-orange mb-5 sticky top-0 z-50"
          }, {
            default: _withCtx(() => _cache[54] || (_cache[54] = [
              _createTextVNode("Non hai i permessi sufficienti per poter creare un contatto ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Field, {
          field_name: "Denominazione",
          required: true,
          errors: _ctx.getErrors('anagrafica_denominazione_id')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.anagraficheAutocomplete.selection,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.anagraficheAutocomplete.selection) = $event)),
              options: _ctx.anagraficheAutocomplete.options,
              taggable: true,
              "clear-on-select": false,
              preserveSearch: true,
              onTag: _cache[4] || (_cache[4] = (value)=>_ctx.anagraficheAutocomplete.add({id:-1, denominazione:value})),
              placeholder: "Denominazione",
              tagPlaceholder: "Crea nuova denominazione",
              class: "next-vue-multiselect-single",
              "track-by": "id",
              label: "denominazione",
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              "internal-search": false,
              onSearchChange: _ctx.anagraficheAutocompleteSarch
            }, {
              option: _withCtx(({option}) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-col text-sm p-3", _ctx.getDenominazioneOptionColor(option)])
                }, [
                  (option.isTag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _cache[55] || (_cache[55] = _createTextVNode("Aggiungi denominazione: ")),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(option.label), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, [
                            _cache[56] || (_cache[56] = _createTextVNode("Denominazione: ")),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(option.denominazione), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _cache[57] || (_cache[57] = _createTextVNode("Ragione sociale: ")),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(option.ragione_sociale), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _cache[58] || (_cache[58] = _createTextVNode("Partita IVA: ")),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(option.partita_iva), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _cache[59] || (_cache[59] = _createTextVNode("CF: ")),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(option.codice_fiscale), 1)
                          ])
                        ])
                      ]))
                ], 2)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onSearchChange"])
          ]),
          _: 1
        }, 8, ["errors"])
      ]),
      _createVNode(_component_AnagraficaAzienda, {
        errors: _ctx.errors,
        "onUpdate:azienda_id": [
          _ctx.onUpdateAziendaId,
          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.azienda_model.azienda_id) = $event))
        ],
        disable_dati_azienda: _ctx.disable_dati_azienda,
        disable_autocomplete_azienda: _ctx.disable_autocomplete_azienda,
        azienda_id: _ctx.azienda_model.azienda_id,
        place_id: _ctx.azienda_model.a_place_id,
        "onUpdate:place_id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.azienda_model.a_place_id) = $event)),
        lat: _ctx.azienda_model.a_lat,
        "onUpdate:lat": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.azienda_model.a_lat) = $event)),
        lng: _ctx.azienda_model.a_lng,
        "onUpdate:lng": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.azienda_model.a_lng) = $event)),
        estera: _ctx.azienda_model.estera,
        "onUpdate:estera": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.azienda_model.estera) = $event)),
        tipo: _ctx.azienda_model.tipo,
        "onUpdate:tipo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.azienda_model.tipo) = $event)),
        partita_iva: _ctx.azienda_model.partita_iva,
        "onUpdate:partita_iva": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.azienda_model.partita_iva) = $event)),
        codice_fiscale: _ctx.azienda_model.codice_fiscale,
        "onUpdate:codice_fiscale": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.azienda_model.codice_fiscale) = $event)),
        ragione_sociale: _ctx.azienda_model.ragione_sociale,
        "onUpdate:ragione_sociale": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.azienda_model.ragione_sociale) = $event)),
        sede_legale_nazione_id: _ctx.azienda_model.sede_legale_nazione_id,
        "onUpdate:sede_legale_nazione_id": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.azienda_model.sede_legale_nazione_id) = $event)),
        sede_legale_provincia_id: _ctx.azienda_model.sede_legale_provincia_id,
        "onUpdate:sede_legale_provincia_id": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.azienda_model.sede_legale_provincia_id) = $event)),
        sede_legale_comune_id: _ctx.azienda_model.sede_legale_comune_id,
        "onUpdate:sede_legale_comune_id": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.azienda_model.sede_legale_comune_id) = $event)),
        sede_legale_regione_estero: _ctx.azienda_model.sede_legale_regione_estero,
        "onUpdate:sede_legale_regione_estero": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.azienda_model.sede_legale_regione_estero) = $event)),
        sede_legale_citta_estero: _ctx.azienda_model.sede_legale_citta_estero,
        "onUpdate:sede_legale_citta_estero": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.azienda_model.sede_legale_citta_estero) = $event)),
        sede_legale_via: _ctx.azienda_model.sede_legale_via,
        "onUpdate:sede_legale_via": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.azienda_model.sede_legale_via) = $event)),
        sede_legale_cap: _ctx.azienda_model.sede_legale_cap,
        "onUpdate:sede_legale_cap": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.azienda_model.sede_legale_cap) = $event)),
        sede_legale_numero: _ctx.azienda_model.sede_legale_numero,
        "onUpdate:sede_legale_numero": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.azienda_model.sede_legale_numero) = $event))
      }, null, 8, ["errors", "onUpdate:azienda_id", "disable_dati_azienda", "disable_autocomplete_azienda", "azienda_id", "place_id", "lat", "lng", "estera", "tipo", "partita_iva", "codice_fiscale", "ragione_sociale", "sede_legale_nazione_id", "sede_legale_provincia_id", "sede_legale_comune_id", "sede_legale_regione_estero", "sede_legale_citta_estero", "sede_legale_via", "sede_legale_cap", "sede_legale_numero"]),
      _createVNode(_component_AnagraficaDenominazione, {
        errors: _ctx.errors,
        disabled: _ctx.disable_dati_denominazione,
        anagrafica_denominazione_id: _ctx.azienda_model.anagrafica_denominazione_id,
        "onUpdate:anagrafica_denominazione_id": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.azienda_model.anagrafica_denominazione_id) = $event)),
        denominazione: _ctx.azienda_model.denominazione,
        "onUpdate:denominazione": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.azienda_model.denominazione) = $event)),
        sito: _ctx.azienda_model.sito,
        "onUpdate:sito": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.azienda_model.sito) = $event)),
        gruppo_di_appartenenza: _ctx.azienda_model.gruppo_di_appartenenza,
        "onUpdate:gruppo_di_appartenenza": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.azienda_model.gruppo_di_appartenenza) = $event)),
        place_id: _ctx.azienda_model.place_id,
        "onUpdate:place_id": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.azienda_model.place_id) = $event)),
        lat: _ctx.azienda_model.lat,
        "onUpdate:lat": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.azienda_model.lat) = $event)),
        lng: _ctx.azienda_model.lng,
        "onUpdate:lng": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.azienda_model.lng) = $event)),
        sede_operativa_via: _ctx.azienda_model.sede_operativa_via,
        "onUpdate:sede_operativa_via": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.azienda_model.sede_operativa_via) = $event)),
        sede_operativa_numero: _ctx.azienda_model.sede_operativa_numero,
        "onUpdate:sede_operativa_numero": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.azienda_model.sede_operativa_numero) = $event)),
        sede_operativa_nazione_id: _ctx.azienda_model.sede_operativa_nazione_id,
        "onUpdate:sede_operativa_nazione_id": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.azienda_model.sede_operativa_nazione_id) = $event)),
        sede_operativa_cap: _ctx.azienda_model.sede_operativa_cap,
        "onUpdate:sede_operativa_cap": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.azienda_model.sede_operativa_cap) = $event)),
        sede_operativa_regione_estero: _ctx.azienda_model.sede_operativa_regione_estero,
        "onUpdate:sede_operativa_regione_estero": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.azienda_model.sede_operativa_regione_estero) = $event)),
        sede_operativa_citta_estero: _ctx.azienda_model.sede_operativa_citta_estero,
        "onUpdate:sede_operativa_citta_estero": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.azienda_model.sede_operativa_citta_estero) = $event)),
        sede_operativa_provincia_id: _ctx.azienda_model.sede_operativa_provincia_id,
        "onUpdate:sede_operativa_provincia_id": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.azienda_model.sede_operativa_provincia_id) = $event)),
        sede_operativa_comune_id: _ctx.azienda_model.sede_operativa_comune_id,
        "onUpdate:sede_operativa_comune_id": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.azienda_model.sede_operativa_comune_id) = $event)),
        email: _ctx.azienda_model.email,
        "onUpdate:email": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.azienda_model.email) = $event)),
        pec: _ctx.azienda_model.pec,
        "onUpdate:pec": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.azienda_model.pec) = $event)),
        telefono_1: _ctx.azienda_model.telefono_1,
        "onUpdate:telefono_1": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.azienda_model.telefono_1) = $event)),
        telefono_2: _ctx.azienda_model.telefono_2,
        "onUpdate:telefono_2": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.azienda_model.telefono_2) = $event)),
        fax: _ctx.azienda_model.fax,
        "onUpdate:fax": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.azienda_model.fax) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.copiaDaSedeLegale,
              class: "w-50 p-3"
            }, {
              default: _withCtx(() => _cache[60] || (_cache[60] = [
                _createTextVNode("Copia dati dalla sede legale")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["errors", "disabled", "anagrafica_denominazione_id", "denominazione", "sito", "gruppo_di_appartenenza", "place_id", "lat", "lng", "sede_operativa_via", "sede_operativa_numero", "sede_operativa_nazione_id", "sede_operativa_cap", "sede_operativa_regione_estero", "sede_operativa_citta_estero", "sede_operativa_provincia_id", "sede_operativa_comune_id", "email", "pec", "telefono_1", "telefono_2", "fax"]),
      _createElementVNode("div", _hoisted_15, [
        _cache[66] || (_cache[66] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Assegnazioni cliente", -1)),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Field, {
            field_name: "Settore commerciale",
            required: true,
            modelValue: _ctx.settoriSelections,
            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.settoriSelections) = $event)),
            errors: _ctx.getErrors('settori')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                trackBy: "descrizione",
                label: "descrizione",
                modelValue: _ctx.settoriSelections,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.settoriSelections) = $event)),
                options: _ctx.settoriOptions,
                multiple: true,
                taggable: false,
                "close-on-select": false,
                "clear-on-select": false,
                class: "next-vue-multiselect",
                placeholder: "Settore commerciale",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                tagPlaceholder: "Aggiungi settore"
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.descrizione), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Field, {
            field_name: "Lavoro new business",
            errors: _ctx.getErrors('lavoro_new_business')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.buAutocomplete.selection,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                options: _ctx.buAutocomplete.options,
                multiple: true,
                disabled: !_ctx.hasPermission('set lavoro_new_business'),
                onSearchChange: _ctx.buAutocomplete.search,
                "close-on-select": false,
                "clear-on-select": false,
                placeholder: "Accounts",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                tagPlaceholder: "Aggiungi account",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "name"
              }, {
                noResult: _withCtx(() => _cache[61] || (_cache[61] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(option.label || ' '), 1),
                      _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(option.label), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(option.nome), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "disabled", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Field, {
            field_name: "Responsabile New Business",
            errors: _ctx.getErrors('responsabile_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.responsabileAutocomplete.search,
                loading: _ctx.responsabileAutocomplete.isLoading,
                options: _ctx.responsabileAutocomplete.options,
                modelValue: _ctx.responsabileAutocomplete.selection,
                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.responsabileAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "name",
                placeholder: "Responsabile new business",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                class: "next-vue-multiselect-single"
              }, {
                noResult: _withCtx(() => _cache[62] || (_cache[62] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(option.bu_label), 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(option.name), 1)
                  ])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(option.bu_label), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_Field, {
            field_name: "Presentazione",
            errors: _ctx.getErrors('presentazioni')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.presentazioneAutocomplete.selection,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.presentazioneAutocomplete.selection) = $event)),
                options: _ctx.presentazioneAutocomplete.options,
                multiple: true,
                onSearchChange: _ctx.presentazioneAutocomplete.search,
                "close-on-select": false,
                "clear-on-select": false,
                placeholder: "Presentazione",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "name"
              }, {
                noResult: _withCtx(() => _cache[63] || (_cache[63] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(option.bu_label || ' '), 1),
                      _createElementVNode("span", null, _toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(option.bu_label), 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_Field, {
            field_name: "Account",
            errors: _ctx.getErrors('accounts')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.accountAutocomplete.selection,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.accountAutocomplete.selection) = $event)),
                options: _ctx.accountAutocomplete.options,
                multiple: true,
                onSearchChange: _ctx.accountAutocomplete.search,
                "close-on-select": false,
                "clear-on-select": false,
                placeholder: "Accounts",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                tagPlaceholder: "Aggiungi account",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "name"
              }, {
                noResult: _withCtx(() => _cache[64] || (_cache[64] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(option.bu_label || ' '), 1),
                      _createElementVNode("span", null, _toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(option.bu_label), 1),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_Field, {
            field_name: "Origine lead",
            required: false,
            errors: _ctx.getErrors('origine_lead')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.origine_lead_model,
                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.origine_lead_model) = $event)),
                options: _ctx.origine_lead_options,
                "close-on-select": true,
                "clear-on-select": false,
                placeholder: "Origine lead",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "text"
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_Field, {
            field_name: "Necessità iscrizione albo fornitori",
            errors: _ctx.getErrors('albo_fornitori')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.albo_fornitori_model,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.albo_fornitori_model) = $event)),
                options: _ctx.albo_fornitori_options,
                multiple: false,
                allowEmpty: false,
                "close-on-select": true,
                "clear-on-select": false,
                placeholder: "Albo fornitori",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "text"
              }, {
                noResult: _withCtx(() => _cache[65] || (_cache[65] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col pb-3", {'hidden': _ctx.azienda_model.albo_fornitori!=='Si'}])
        }, [
          _createVNode(_component_Field, {
            field_name: "Data limite iscrizione albo fornitori",
            errors: _ctx.getErrors('data_albo_fornitori')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.azienda_model.albo_fornitori !== 'Si',
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.azienda_model.data_albo_fornitori) = $event)),
                type: "date",
                class: "flex-grow p-7px bg-next-gray-md-dark group-hover:bg-white"
              }, null, 8, _hoisted_36), [
                [_vModelText, _ctx.azienda_model.data_albo_fornitori]
              ])
            ]),
            _: 1
          }, 8, ["errors"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col pb-3 col-span-3", {'hidden': _ctx.azienda_model.albo_fornitori!=='Si'}])
        }, [
          _createVNode(_component_Field, {
            field_name: "Link portale di iscrizione",
            errors: _ctx.getErrors('link_portale')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.azienda_model.albo_fornitori !== 'Si',
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.azienda_model.link_portale) = $event)),
                type: "url",
                class: "p-2 bg-next-gray-md-dark hover:bg-white w-full"
              }, null, 8, _hoisted_37), [
                [_vModelText, _ctx.azienda_model.link_portale]
              ])
            ]),
            _: 1
          }, 8, ["errors"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          component: "router-link",
          to: {name:'Dashboard'},
          class: "w-48 flex-shrink py-2 px-4"
        }, {
          default: _withCtx(() => _cache[67] || (_cache[67] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _ctx.save,
          disabled: _ctx.saving,
          class: "w-48 flex-shrink ml-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[68] || (_cache[68] = [
            _createTextVNode(" Salva ")
          ])),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ])
  ]))
}